import { render } from "./CustomInputText.vue?vue&type=template&id=707865cd"
import script from "./CustomInputText.vue?vue&type=script&lang=js"
export * from "./CustomInputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__